/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BookingConfirmed1FromJSONTyped, BookingConfirmed1ToJSON, } from './BookingConfirmed1.js';
import { CfarDenyPurchaseFromJSONTyped, CfarDenyPurchaseToJSON, } from './CfarDenyPurchase.js';
import { CfarEventWithContractFromJSONTyped, CfarEventWithContractToJSON, } from './CfarEventWithContract.js';
import { CfarExerciseCallbackLaunchedFromJSONTyped, CfarExerciseCallbackLaunchedToJSON, } from './CfarExerciseCallbackLaunched.js';
import { CfarExerciseCustomerDataCompleteFromJSONTyped, CfarExerciseCustomerDataCompleteToJSON, } from './CfarExerciseCustomerDataComplete.js';
import { CfarExercisePortalCompleteFromJSONTyped, CfarExercisePortalCompleteToJSON, } from './CfarExercisePortalComplete.js';
import { CfarExercisePortalDisplayFromJSONTyped, CfarExercisePortalDisplayToJSON, } from './CfarExercisePortalDisplay.js';
import { CfarExerciseVerificationCompleteFromJSONTyped, CfarExerciseVerificationCompleteToJSON, } from './CfarExerciseVerificationComplete.js';
import { CfarExerciseVerificationSentFromJSONTyped, CfarExerciseVerificationSentToJSON, } from './CfarExerciseVerificationSent.js';
import { CfarForcedChoiceWarningFromJSONTyped, CfarForcedChoiceWarningToJSON, } from './CfarForcedChoiceWarning.js';
import { CfarOffersBannerDisplayFromJSONTyped, CfarOffersBannerDisplayToJSON, } from './CfarOffersBannerDisplay.js';
import { CfarOffersTakeoverDisplayFromJSONTyped, CfarOffersTakeoverDisplayToJSON, } from './CfarOffersTakeoverDisplay.js';
import { CfarViewInfoFromJSONTyped, CfarViewInfoToJSON, } from './CfarViewInfo.js';
import { OffersDisplayed1FromJSONTyped, OffersDisplayed1ToJSON, } from './OffersDisplayed1.js';
export function CfarEventFromJSON(json) {
    return CfarEventFromJSONTyped(json, false);
}
export function CfarEventFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'booking_confirmed':
            return Object.assign(Object.assign({}, BookingConfirmed1FromJSONTyped(json, true)), { type: 'booking_confirmed' });
        case 'cfar_deny_purchase':
            return Object.assign(Object.assign({}, CfarDenyPurchaseFromJSONTyped(json, true)), { type: 'cfar_deny_purchase' });
        case 'cfar_event_with_contract':
            return Object.assign(Object.assign({}, CfarEventWithContractFromJSONTyped(json, true)), { type: 'cfar_event_with_contract' });
        case 'cfar_exercise_callback_launched':
            return Object.assign(Object.assign({}, CfarExerciseCallbackLaunchedFromJSONTyped(json, true)), { type: 'cfar_exercise_callback_launched' });
        case 'cfar_exercise_customer_data_complete':
            return Object.assign(Object.assign({}, CfarExerciseCustomerDataCompleteFromJSONTyped(json, true)), { type: 'cfar_exercise_customer_data_complete' });
        case 'cfar_exercise_portal_complete':
            return Object.assign(Object.assign({}, CfarExercisePortalCompleteFromJSONTyped(json, true)), { type: 'cfar_exercise_portal_complete' });
        case 'cfar_exercise_portal_display':
            return Object.assign(Object.assign({}, CfarExercisePortalDisplayFromJSONTyped(json, true)), { type: 'cfar_exercise_portal_display' });
        case 'cfar_exercise_verification_complete':
            return Object.assign(Object.assign({}, CfarExerciseVerificationCompleteFromJSONTyped(json, true)), { type: 'cfar_exercise_verification_complete' });
        case 'cfar_exercise_verification_sent':
            return Object.assign(Object.assign({}, CfarExerciseVerificationSentFromJSONTyped(json, true)), { type: 'cfar_exercise_verification_sent' });
        case 'cfar_forced_choice_warning':
            return Object.assign(Object.assign({}, CfarForcedChoiceWarningFromJSONTyped(json, true)), { type: 'cfar_forced_choice_warning' });
        case 'cfar_offers_banner_display':
            return Object.assign(Object.assign({}, CfarOffersBannerDisplayFromJSONTyped(json, true)), { type: 'cfar_offers_banner_display' });
        case 'cfar_offers_takeover_display':
            return Object.assign(Object.assign({}, CfarOffersTakeoverDisplayFromJSONTyped(json, true)), { type: 'cfar_offers_takeover_display' });
        case 'cfar_view_info':
            return Object.assign(Object.assign({}, CfarViewInfoFromJSONTyped(json, true)), { type: 'cfar_view_info' });
        case 'offers_displayed':
            return Object.assign(Object.assign({}, OffersDisplayed1FromJSONTyped(json, true)), { type: 'offers_displayed' });
        default:
            throw new Error(`No variant of CfarEvent exists with 'type=${json['type']}'`);
    }
}
export function CfarEventToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'booking_confirmed':
            return BookingConfirmed1ToJSON(value);
        case 'cfar_deny_purchase':
            return CfarDenyPurchaseToJSON(value);
        case 'cfar_event_with_contract':
            return CfarEventWithContractToJSON(value);
        case 'cfar_exercise_callback_launched':
            return CfarExerciseCallbackLaunchedToJSON(value);
        case 'cfar_exercise_customer_data_complete':
            return CfarExerciseCustomerDataCompleteToJSON(value);
        case 'cfar_exercise_portal_complete':
            return CfarExercisePortalCompleteToJSON(value);
        case 'cfar_exercise_portal_display':
            return CfarExercisePortalDisplayToJSON(value);
        case 'cfar_exercise_verification_complete':
            return CfarExerciseVerificationCompleteToJSON(value);
        case 'cfar_exercise_verification_sent':
            return CfarExerciseVerificationSentToJSON(value);
        case 'cfar_forced_choice_warning':
            return CfarForcedChoiceWarningToJSON(value);
        case 'cfar_offers_banner_display':
            return CfarOffersBannerDisplayToJSON(value);
        case 'cfar_offers_takeover_display':
            return CfarOffersTakeoverDisplayToJSON(value);
        case 'cfar_view_info':
            return CfarViewInfoToJSON(value);
        case 'offers_displayed':
            return OffersDisplayed1ToJSON(value);
        default:
            throw new Error(`No variant of CfarEvent exists with 'type=${value['type']}'`);
    }
}
